export default "__VITE_PUBLIC_ASSET__1085361c__"